import React from 'react';
import s from './ModalWindow.module.css'

const ModalWindow = ({text, closeWindow}) => {
    return (
        <div className={s.wrapper}>
            <div className={s.window}>
                <div className={s.text}>{text}</div>
                <div className={s.buttons_wrapper}>
                    <div onClick={closeWindow} className={s.btn_ok}>Закрыть</div>
                </div>

            </div>
        </div>
    );
};

export default ModalWindow;